import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { DocumentoService } from '../../services/documento.service'
import { AlertService } from '../../providers/alert.service'


@Component({
	selector: 'app-pdf-view',
	templateUrl: './pdf-view.component.html',
	styleUrls: ['./pdf-view.component.scss', '../../assets/less/all.less']
})
export class PdfViewComponent implements OnInit {
	loading = false
	visible = false
	id;
	documento;
	private sub: any;
	constructor(
		public activated_router: ActivatedRoute,
		private ref: ChangeDetectorRef,
		public alerts: AlertService,
		public documento_service: DocumentoService,
		private router: Router,
	) { }

	ngOnInit() {
		this.sub = this.activated_router.params.subscribe(params => {
			this.id = params['id'];
			if (this.id != 0) {
				this.getPdf()
			}

		});

	}

	getPdf() {
		this.loading = true
		console.log('download')
		this.documento_service.getPDF(this.id)
			.subscribe(x => {
				var newBlob = new Blob([x], { type: "application/pdf" });
				console.log('then', x)
				if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(newBlob);
					return;
				}
				const data = window.URL.createObjectURL(newBlob);
				this.documento = data
				console.log("documento", this.documento)
				this.visible = true
				this.loading = false
			},
				error => {
					this.loading = false
					this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
				})

	}

	voltar(){
		this.router.navigate(['documentos-ged'])
	}

}
